import { Component } from '@angular/core';

@Component({
    selector: 'app-offer-crosssale-bundle',
    imports: [],
    templateUrl: './offer-crosssale-bundle.component.html',
    styleUrl: './offer-crosssale-bundle.component.scss'
})
export class OfferCrosssaleBundleComponent {

}
